export default function removeHours(timezoneString: string | undefined) {
  const parts = timezoneString?.split(' (') ?? [];

  return parts[0] ?? '';
}
